import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioPlazaCobro from '../servicios/ServicioPlazaCobro';
export class PlazaCobro extends Component {
    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 20
            },
            inicio: 0,
            plaza: {},
            errores: {},
            mostrarModalPlaza: false,
            erroresRequeridos: {},
            confirmacionEliminarPlaza: false,
            estado: {},
            estados_plaza: [
                { name: 'Activo', code: 1 },
                { name: 'Desactivado', code: 0 }
            ]

        }

    }
    componentDidMount() {
        this.obtenerPagina();

    }

    cambiaPagina(event) {
        let { paginacion } = this.state;

        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }

    obtenerPagina() {
        let { paginacion } = this.state;
        servicioPlazaCobro.paginacion(paginacion).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });


        }).catch((error) => {
            if (error)
                return this.growl.show({ life: 4000, severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });

    }

    buscarLike = (e) => {
        let { plaza, paginacion } = this.state;

        servicioPlazaCobro.buscarLike(plaza).then((response) => {
            if (response.data.lista.length === 0) {
                this.growl.show({ life: 6000, severity: 'error', summary: '', detail: 'No existe informaci\u00f3n con los valores ingresados, verifica tus datos' });
                paginacion['datos'] = response.data.lista;
                this.setState({ valorencontrado: response.data, paginacion });
            } else {
                this.growl.show({ life: 1000, severity: 'success', summary: '', detail: "Valores encontrados" });
                paginacion['datos'] = response.data.lista;
                this.setState({ valorencontrado: response.data.lista, paginacion });
            }
        }).catch((error) => {
            if (error.status === 500)
                this.growl.show({ life: 6000, severity: 'error', summary: '', detail: 'Lo sentimos, no hay información disponible.' });
        });

    }
    guardar = () => {
        let { plaza } = this.state;


        const validacion = this.validarFormulario(plaza);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
            var plazaEnvio = JSON.parse(JSON.stringify(plaza));
            let estado = plazaEnvio.estado.code;
            delete plazaEnvio['estado'];
            plazaEnvio.estado = estado;
            servicioPlazaCobro.guardar(plazaEnvio).then((response) => {
                this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false)
                    this.setState({ plaza: {}, mostrarModalPlaza: false });
                this.obtenerPagina();

            }).catch((error) => {
                if (error)
                    return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
            });
        }

    }
    eliminar = () => {
        let { plaza } = this.state;

        servicioPlazaCobro.eliminar(plaza).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false)
                this.setState({ plaza: {}, mostrarModalPlaza: false, confirmacionEliminarPlaza: false });
            this.obtenerPagina();

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }
    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);

    }
    editarPlaza = (rowData, column) => {

        return <div>
            <center>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-edit" className="p-button-success" name="editar"
                    tooltip="editar" onClick={(e) => this.editar(column.rowData)} >
                </Button>
            </div>
            </center>
        </div>;
    }
    eliminarPlaza = (rowData, column) => {

        return <div>            
            <center>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-delete" className="p-button-warning" name="eliminar"
                    tooltip="eliminar" onClick={(e) => this.mostrarModalEliminar(column.rowData)} >
                </Button>
            </div>
            </center>
        </div>;
    }
    validarFormulario = (plaza, estado) => {
        const errores = {};
        if (!plaza.nombre)
            errores.nombre = "El nombre es requerido";
        if (!plaza.numero)
            errores.numero = "El número es requerido";
        if (!plaza.estado)
            errores.estado = "El estado es requerido";
        return errores;
    }
    editar(objeto) {
        let { estados_plaza } = this.state;
        let estado_plaza = estados_plaza.filter(obj => {
            return obj.code === objeto.estado;
        });
        var plazaEditar = JSON.parse(JSON.stringify(objeto));
        let estado = estado_plaza[0];
        delete plazaEditar['estado'];
        plazaEditar.estado = estado;

        this.setState({ mostrarModalPlaza: true, plaza: plazaEditar });
    }
    nuevo() {
        this.setState({ mostrarModalPlaza: true, plaza: {} });
    }
    mostrarModalEliminar = (objeto) => {
        this.setState({ confirmacionEliminarPlaza: true, plaza: objeto });
    }
    formatoEstado = (rowData, column) => {
        if (rowData.estado === 1)
            return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8, justifyContent:'center'}}>Activo</p>;
        else
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Desactivado</p>
    }
    render() {
        const { plaza, paginacion, inicio, erroresRequeridos, estados_plaza } = this.state;
        const dialogFooter = (
            <div>
                <Button icon="pi-md-check" onClick={this.guardar} label="Guardar" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ plaza: {}, mostrarModalPlaza: false, erroresRequeridos: {} })} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );
        const dialogFooterConfirmacionEliminarPlaza = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ plaza: {}, confirmacionEliminarPlaza: false, erroresRequeridos: {} })} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        return (<div className="card card-w-title">
            <Growl ref={(el) => this.growl = el} />
            <h1 style={{marginBottom:'30px'}}>Plaza de Cobro</h1>
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                    <Button type="button" className="blue-grey-btn flat-btn" label="Nueva Plaza" name="nuevo" value="Nuevo"
                        tooltip="nuevo" onClick={(e) => this.nuevo()} >
                    </Button>
                </div>
                <div className="p-col-12" style={{marginTop:'30px', fontWeight:'bold', marginLeft:'5px'}}>
                    <label htmlFor="buscar">Buscar plaza de cobro:</label>
                </div>
                <div className="p-col-12 p-md-6" style={{marginLeft:'5px', marginBottom:'30px'}}>
                    <InputText className="p-inputtext" size={100} placeholder="Buscar por Nombre " name="plaza.nombre" value={plaza.nombre || ''} onChange={this.asignarValoresObjeto} onKeyUp={this.buscarLike.bind(this)} />
                </div>
            </div>
            <Card style={{marginBottom:'50px'}}>
                <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px">
                    <Column field="nombre" header="Nombre" style={{ width: '200px', textAlign:'center'}} filter={false} autoLayout={true} />
                    <Column field="numero" header="Número" style={{ width: '200px', textAlign:'center'}} filter={false} autoLayout={true} />
                    <Column field="estado" header="Estado" body={this.formatoEstado} style={{ width: '100px', textAlign:'center' }} filter={false} autoLayout={true} />

                    <Column header="Editar" body={this.editarPlaza.bind(this)} style={{ width: '100px', textAlign:'center'}} />
                    <Column header="Eliminar" body={this.eliminarPlaza.bind(this)} style={{ width: '100px', textAlign:'center'}} />
                </DataTable>
                <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
            </Card>
            <Dialog header="Plaza de Cobro, los campos con * son requeridos." blockScroll visible={this.state.mostrarModalPlaza} modal={true} footer={dialogFooter} style={{ width: '60vw' }} onHide={() => this.setState({ plaza: {}, mostrarModalPlaza: false, erroresRequeridos: {} })}>
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="nombre">* Nombre:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="nombre" name="plaza.nombre" value={plaza.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.nombre ? 'p-error' : ''} />
                        {erroresRequeridos.nombre ? <div> <Message severity="error" text={erroresRequeridos.nombre} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="numero">* Número:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <InputText id="numero" name="plaza.numero" value={plaza.numero || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.numero ? 'p-error' : ''} />
                        {erroresRequeridos.numero ? <div> <Message severity="error" text={erroresRequeridos.numero} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="estado">* Estado:</label>
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Dropdown id="estado" name="plaza.estado" options={estados_plaza} value={plaza.estado} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" className={erroresRequeridos.estado ? 'p-error' : ''} />
                        {erroresRequeridos.estado ? <div> <Message severity="error" text={erroresRequeridos.estado} /> </div> : null}
                    </div>
                </div>
            </Dialog>
            <Dialog header="Confirmación" visible={this.state.confirmacionEliminarPlaza} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminarPlaza} onHide={() => this.setState({ plaza: {}, confirmacionEliminarPlaza: false, erroresRequeridos: {} })}>
                <h2>¿Estás seguro de eliminar la plaza de cobro?</h2>
            </Dialog>
        </div>);
    }

}